export function get(url: string, requestOptions?: RequestInit) {

	const defaultOptions = {
		method: 'get',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		}
	};

	const combinedOptions = { ...defaultOptions, ...requestOptions } as RequestInit;

	return fetch(url, combinedOptions);
}

export function post(url: string, body?: any, requestOptions?: RequestInit) {

	const defaultOptions = {
		method: 'post',
		cache: 'no-cache',
		credentials: 'same-origin',
		body: body ? JSON.stringify(body) : null,
		headers: {
			'Content-Type': 'application/json'
		}
	};

	const combinedOptions = { ...defaultOptions, ...requestOptions } as RequestInit;

	return fetch(url, combinedOptions);
}

export function put(url: string, body: any, requestOptions?: RequestInit) {

	const defaultOptions = {
		method: 'put',
		cache: 'no-cache',
		credentials: 'same-origin',
		body: JSON.stringify(body),
		headers: {
			'Content-Type': 'application/json'
		}
	};

	const combinedOptions = { ...defaultOptions, ...requestOptions } as RequestInit;

	return fetch(url, combinedOptions);
}

export function deleteRequest(url: string, requestOptions?: RequestInit) {

	const defaultOptions = {
		method: 'delete',
		cache: 'no-cache',
		credentials: 'same-origin'
	};

	const combinedOptions = { ...defaultOptions, ...requestOptions } as RequestInit;

	return fetch(url, combinedOptions);
}

export function checkStatus(response: Response) {
	if (response.status >= 200 && response.status < 300) {
		return Promise.resolve(response);
	} else {
		return Promise.reject(new Error(response.statusText));
	}
}

// checkStatus() builds its error from response.statusText, which browsers often leave empty over
// HTTP/2 (no textual status line in the protocol) - resulting in an uninformative "Error" message
// with no status code at all. This keeps the status code (and body, if any) so failures are
// actually diagnosable.
export async function checkStatusVerbose(response: Response): Promise<Response> {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}
	const statusText = `${response.status}${
		response.statusText ? ` ${response.statusText}` : ""
	}`;
	let bodyText = "";
	try {
		bodyText = (await response.clone().text()).slice(0, 300);
	} catch {
		// body unreadable/already consumed - fall back to just the status
	}
	throw new Error(bodyText ? `${statusText}: ${bodyText}` : statusText);
}

export function toJson(response: Response) {
	return response.json();
}

/**
	* Some endpoints return 200 but have a Success boolean that is false
	*/
export function checkSucessBoolean(data: any) {
	if (data.Success) {
		return Promise.resolve(data);
	} else {
		return Promise.reject(new Error(data.Message));
	}
}
